import styled from "styled-components/macro";
import {
  MODAL_ARROW_HEIGHT,
  MODAL_PADDING,
  MODAL_OFFSET_TOP_WITHOUT_TAG,
  MODAL_ARROW_OFFSET_LEFT,
  BOX_SHADOW_TOOLTIP,
  MODAL_WIDTH,
  Z_INDEX,
} from "../../../../constants/constants";
import {
  medText,
  darkGrey,
  darkModeModalBackgroundColor,
  darkModeTextColor,
  darkModeDarkTextColor,
  darkBlue,
  darkModeTabIndicatorColor,
  lightSurface3,
} from "../../../../constants/colors";
import { CUSTOM_SCROLLBAR_CSS } from "App/CUSTOM_SCROLLBAR_CSS";
import { MODAL_HEIGHT } from "reports/constants/constants";

const TOOLTIP_BORDER_RADIUS = 5;
const TOOLTIP_OFFSET_MOBILE = -40;
export const MODAL_TEXT_ROW_HEIGHT = 24;

export const TimelineTooltipStyles = styled.div<{
  $isDarkMode: boolean;
  $isModalPinned: boolean;
  $removeRetrotagFormOpen: boolean;
  $modalOffsetTop: number;
  $modalOffsetTopUpwardPointing: number;
  $modalHeight: number;
  $deltaX: number;
  $modalOffsetRight: number;
  $pnlColor: string;
}>`
  pointer-events: ${props => (props.$isModalPinned ? "auto" : "none")};
  .MuiButtonBase-root {
    color: ${({ $isDarkMode }) => ($isDarkMode ? darkModeTextColor : "black")};
  }
  .clickedTime {
    margin-left: -14px;
    &.bottom {
      height: 13px;
      margin-top: -3px;
    }
    &.top {
      height: 19px;
      margin-top: -8px;
    }
    color: ${({ $isDarkMode }) =>
      $isDarkMode ? darkModeDarkTextColor : darkGrey};
    opacity: 0.8;
    text-align: center;
    font-size: 0.75em;
  }
  .removeRetrotagForm {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    .backdrop {
      background: ${({ $isDarkMode }) =>
        $isDarkMode ? darkModeModalBackgroundColor : "white"};
      opacity: 0.5;
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: ${Z_INDEX.L9};
      border-radius: ${TOOLTIP_BORDER_RADIUS}px;
      display: ${props => (props.$removeRetrotagFormOpen ? "inherit" : "none")};
    }
    .removeRetrotagFormPaper {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      background: ${({ $isDarkMode }) =>
        $isDarkMode ? darkModeModalBackgroundColor : "white"};
      color: ${({ $isDarkMode }) =>
        $isDarkMode ? darkModeTextColor : "#000000"};
      position: absolute;
      border-radius: 4px;
      right: 15%;
      left: 15%;
      top: 25%;
      padding: 15px 20px;
      text-align: center;
      z-index: ${Z_INDEX.L10};
      .bottomButtons {
        display: flex;
        flex-direction: row;
        .MuiButton-root {
          &.cancelButton {
            color: #999999;
            padding: 6px 30px;
          }
          &.deleteButton {
            color: #4ba3d1;
            padding: 6px 30px;
            font-weight: bold;
          }
        }
        button {
          text-transform: none;
        }
      }
    }
  }
  .modal {
    font-family: "Roboto";
    font-size: 14px;
    border-radius: ${TOOLTIP_BORDER_RADIUS}px;
    margin-top: ${props =>
      -MODAL_OFFSET_TOP_WITHOUT_TAG +
      props.$modalOffsetTop +
      props.$modalOffsetTopUpwardPointing}px;
    min-height: ${props => props.$modalHeight - props.$modalOffsetTop}px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    position: relative;
    background: ${({ $isDarkMode }) =>
      $isDarkMode ? darkModeModalBackgroundColor : "white"};
    box-shadow: ${props =>
      props.$removeRetrotagFormOpen ? "none" : BOX_SHADOW_TOOLTIP};
    padding: ${MODAL_PADDING}px;
    padding-bottom: 0;
    line-height: 16pt;
    color: ${({ $isDarkMode }) =>
      $isDarkMode ? darkModeDarkTextColor : medText};
    .MuiTabs-indicator {
      background-color: ${({ $isDarkMode }) =>
        $isDarkMode ? darkModeTabIndicatorColor : darkBlue};
    }
    .sectionHeader {
      margin-top: 5px;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${({ $isDarkMode }) =>
        $isDarkMode ? darkModeTextColor : "#000000"};
      .MuiIconButton-root.retrotagButton {
        margin: -14px -14px -11px -8px;
        padding: 14px;
        font-size: 14px;
      }
      .MuiSvgIcon-root {
        font-size: 18px;
        color: #4ba3d1;
      }
      .MuiButtonBase-root.Mui-disabled {
        opacity: 0.5;
      }
    }
    .pnlCategory {
      margin-top: 7px;
      font-size: 15px;
      color: ${({ $isDarkMode }) =>
        $isDarkMode ? darkModeTextColor : "#000000"};
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: center;
      .pnlColorCircle {
        height: 16px;
        width: 16px;
        margin-right: 7px;
        margin-top: -2px;
        box-sizing: border-box;
        border: 1px solid black;
        background: ${props => props.$pnlColor};
        border-radius: 999px;
        right: 0;
      }
    }
    .panel {
      margin: auto;
      overflow-wrap: break-word;
      min-width: ${MODAL_WIDTH - 2 * MODAL_PADDING}px;
      overflow-y: auto;
      overflow-x: hidden;
      .bulletList {
        li {
          list-style-type: disc;
          display: list-item;
          margin: 0 0 0 20px;
        }
      }
    }
    .about {
      overflow-y: hidden;
    }
    .moreInfo {
      max-width: ${MODAL_WIDTH - 2 * MODAL_PADDING}px;
      height: ${MODAL_HEIGHT + 21}px;
      margin-top: 0;
      margin-bottom: -10px;
      padding-bottom: 10px;
      ${CUSTOM_SCROLLBAR_CSS}
      margin-right: -12px;
      padding-right: 12px;
      &.multiComment {
        margin-right: -8px;
        padding-right: 8px;
      }
      .timerangeShort {
        position: relative;
        text-align: center;
        font-size: 0.8em;
        height: 16px;
        margin-top: -2px;
      }
    }
    .tabs {
      margin: 0 -${MODAL_PADDING}px;
      padding-top: 10px;
    }
    .textAlignCenter {
      text-align: center;
    }
    .noWrap {
      white-space: nowrap;
    }
    .datetime {
      svg {
        align-self: center;
      }
    }
    .btnClose {
      position: absolute;
      transform: scale(1);
      top: -8px;
      right: -8px;
      z-index: ${Z_INDEX.L11};
    }
    .centeredGrid {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .tag {
      }
    }

    .skuOperatorTimelineInfoRow {
      height: ${MODAL_TEXT_ROW_HEIGHT}px;
      max-width: ${MODAL_WIDTH - 2 * MODAL_PADDING}px;
      white-space: nowrap;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      line-height: 1.8;
      &:not(:last-child) {
        border-bottom: 1px solid ${lightSurface3};
      }
    }
    .operatorAvatar {
      border-radius: 999px;
      height: 18px;
      width: 18px;
      box-sizing: border-box;
      font-size: 10px;
      margin-left: auto;
      margin-right: 4px;
      display: flex;
      align-items: center;
      align-self: center;
      justify-content: center;
    }

    /* add class "arrowBottom / arrowTop" to TimelineTooltipStyles component for bottom or top arrow */
    &.arrowBottom:before,
    &.arrowTop:before {
      content: "";
      position: absolute;
      width: 0;
      height: 0;
      left: calc(
        50% -
          ${props =>
            MODAL_ARROW_OFFSET_LEFT +
            props.$deltaX +
            props.$modalOffsetRight -
            MODAL_PADDING}px
      );
      @media (max-width: 480px) {
        left: calc(
          50% -
            ${props =>
              MODAL_ARROW_OFFSET_LEFT +
              props.$deltaX +
              props.$modalOffsetRight +
              TOOLTIP_OFFSET_MOBILE}px
        );
      }
      border: ${MODAL_ARROW_HEIGHT}px solid black;
      transform-origin: 0 0;
      transform: scaleX(0.45) translateX(${MODAL_ARROW_HEIGHT + 12}px)
        rotate(-45deg);
    }
    &.arrowBottom:before {
      bottom: -36px;
      border-color: transparent transparent
        ${({ $removeRetrotagFormOpen, $isDarkMode }) =>
          $removeRetrotagFormOpen
            ? "rgba(0, 0, 0, 0.5) rgba(0, 0, 0, 0.5)"
            : $isDarkMode
              ? `${darkModeModalBackgroundColor} ${darkModeModalBackgroundColor}`
              : "white white"};
      box-shadow: -1px 7px 4px -2px rgba(0, 0, 0, 0.2);
    }
    &.arrowTop:before {
      top: 0px;
      border-color: ${({ $removeRetrotagFormOpen, $isDarkMode }) =>
          $removeRetrotagFormOpen
            ? "rgba(0, 0, 0, 0.5) rgba(0, 0, 0, 0.5)"
            : $isDarkMode
              ? `${darkModeModalBackgroundColor} ${darkModeModalBackgroundColor}`
              : "white white"}
        transparent transparent;
      box-shadow: 4px 0px 4px -2px rgba(0, 0, 0, 0.2);
    }
  }

  @media (max-width: 480px) {
    .modal {
      transform: translateX(${TOOLTIP_OFFSET_MOBILE}px);
    }
  }
`;
